import { useTranslation } from "react-i18next";
import defaultContent from "../../../content/profile";
import { IconWhatsApp } from "../../../common/icons/IconWhatsApp/IconWhatsApp";
import "./ABOWhatsApp.scss";

type Props = {
  whatsAppContactNumber: string;
  applicantTrackOnclick: Function;
  privacyFlag: boolean;
};

const ABOWhatsApp = ({ whatsAppContactNumber, applicantTrackOnclick, privacyFlag }: Props) => {
  const { t } = useTranslation(["profile"]);

  const isValidWhatsAppContact = whatsAppContactNumber && whatsAppContactNumber !== "--" && !privacyFlag;
  const displayWhatsApp = isValidWhatsAppContact ? whatsAppContactNumber : "-";

  return (
    <div className="abo-whats-app">
      <div className="abo-whats-app__content">
        <div className="abo-whats-app__label">{`${t("leaf.whatsApp", defaultContent["leaf"]["whatsApp"])}`}</div>
        <div className="abo-whats-app__number">{displayWhatsApp}</div>
      </div>
      {isValidWhatsAppContact && (
        <a
          href={`whatsapp://send?phone=${whatsAppContactNumber}`}
          target="_blank"
          rel="noreferrer"
          onClick={() => applicantTrackOnclick("message")}
        >
          <IconWhatsApp />
        </a>
      )}
    </div>
  );
};

export default ABOWhatsApp;
